import { BaseService } from "../../core/baseService";
import { ApiResult } from "../../core/types";
import {
  OnboardingStatusDto,
  HotelDetailsDto,
  ContactInfoDto,
  SaveHotelDetailsRequest,
  SaveContactInfoRequest,
  UpdateProgressRequest,
} from "../types/onboarding.types";
import { AllPricingTiers } from "../types/billing.types";

export interface OnboardingServiceInterface {
  getStatus(): Promise<ApiResult<OnboardingStatusDto>>;
  updateProgress(request: UpdateProgressRequest): Promise<ApiResult<void>>;
  complete(): Promise<ApiResult<void>>;
  reset(): Promise<ApiResult<void>>;
  getHotelDetails(): Promise<ApiResult<HotelDetailsDto>>;
  saveHotelDetails(request: SaveHotelDetailsRequest): Promise<ApiResult<void>>;
  getContactInfo(): Promise<ApiResult<ContactInfoDto>>;
  saveContactInfo(request: SaveContactInfoRequest): Promise<ApiResult<void>>;
  getPricing(): Promise<ApiResult<AllPricingTiers>>;
}

export class OnboardingService
  extends BaseService
  implements OnboardingServiceInterface
{
  async getStatus(): Promise<ApiResult<OnboardingStatusDto>> {
    return this.handleRequest<OnboardingStatusDto>(
      this.client.get("/api/admin/onboarding/status"),
    );
  }

  async updateProgress(request: UpdateProgressRequest): Promise<ApiResult<void>> {
    return this.handleRequest<void>(
      this.client.post("/api/admin/onboarding/progress", request),
    );
  }

  async complete(): Promise<ApiResult<void>> {
    return this.handleRequest<void>(
      this.client.post("/api/admin/onboarding/complete"),
    );
  }

  async reset(): Promise<ApiResult<void>> {
    return this.handleRequest<void>(
      this.client.post("/api/admin/onboarding/reset"),
    );
  }

  async getHotelDetails(): Promise<ApiResult<HotelDetailsDto>> {
    return this.handleRequest<HotelDetailsDto>(
      this.client.get("/api/admin/onboarding/hotel-details"),
    );
  }

  async saveHotelDetails(request: SaveHotelDetailsRequest): Promise<ApiResult<void>> {
    return this.handleRequest<void>(
      this.client.post("/api/admin/onboarding/hotel-details", request),
    );
  }

  async getContactInfo(): Promise<ApiResult<ContactInfoDto>> {
    return this.handleRequest<ContactInfoDto>(
      this.client.get("/api/admin/onboarding/contact-info"),
    );
  }

  async saveContactInfo(request: SaveContactInfoRequest): Promise<ApiResult<void>> {
    return this.handleRequest<void>(
      this.client.post("/api/admin/onboarding/contact-info", request),
    );
  }

  async getPricing(): Promise<ApiResult<AllPricingTiers>> {
    return this.handleRequest<AllPricingTiers>(
      this.client.get("/api/admin/onboarding/pricing"),
    );
  }
}
